import Avatar from "@components/ui-components/avatar";
import { Badge } from "reactstrap";
import CopyToClipboard from "@components/ui-components/copy-to-clipboard";
import { DATE_FORMAT_VIEW } from "@src/utility/constants";
import Flex from "@components/ui-components/flex";
import LoadingButton from "@components/ui-components/loading-button";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import { getStatusBadge } from "@src/utility/helpers/utils";
import size from "lodash/size";
import upperCase from "lodash/upperCase";
import useDateHandler from "@hooks/use-date-handler";
import { useTranslation } from "react-i18next";

export const decoColumns = ({ handleRowActions }) => {
    
    const { t } = useTranslation();
    const { dateFormatter } = useDateHandler();

    return [
        {
            name    : "Name",
            selector: row => row.name,
            width   : "300px",
            cell    : row => (
                <Flex align="center">
                    <Avatar
                        color={getStatusBadge(row?.status).color}
                        img={size(row.pp) ? row?.pp : false}
                        content={row?.name}
                        initials={!size(row?.pp)}/>
                    <div>
                        <LongNameFormatter
                            content={row.name}
                            className="fw-bold"
                            id={`user-name-${row._id}`}
                            max={100}/>
                        <Badge color={getStatusBadge(row.status).color}>
                            {t(getStatusBadge(row.status).title)}
                        </Badge>
                    </div>
                </Flex>
            )
        },
        {
            name    : "Contact Details",
            selector: row => row.name,
            width   : "300px",
            cell    : row => (
                <Flex column>
                    <Flex align="center">
                        <small>{row?.phone || "-"}</small> &nbsp;
                        {row?.phone ? (
                            <CopyToClipboard className="ms-75" text={row?.phone} />
                        ) : null}
                    </Flex>
                    <LongNameFormatter
                        className="font-small-3 text-wrap mt-50"
                        content={row.email }
                        copyTxt={row.email}
                        max={50}
                        id={`email-${row?.id}`}/>
                </Flex>
            )
        },
        {
            name    : "Role",
            selector: (row) => row.role,
            width   : "120px",
            cell    : (row) => {
                const statusBadge = getStatusBadge(row.role);
                return (
                    <Badge color={statusBadge?.color}>
                        {upperCase(statusBadge?.title)}
                    </Badge>
                );
            }
        },
        {
            name    : "Products",
            minWidth: "250px",
            selector: row => row.platforms,
            cell    : row => (
                <Flex wrap>
                    {Array.isArray(row.platforms) ? row.platforms?.map(item => (
                        <Badge color="secondary" className="mb-25 me-25">
                            {t(item.name)}
                        </Badge>
                    )) : "-"}
                </Flex>
            )
        },
        {
            name    : "Tags",
            minWidth: "250px",
            selector: row => row.tags,
            cell    : row => (
                <Flex wrap>
                    {size(row.tags) ? row.tags.map(item => (
                        <Badge color="primary" className="mb-25">
                            {item.name}
                        </Badge>
                    )) : "-"}
                </Flex>
            )
        },
        {
            name    : "Created On",
            selector: row => row.createdAt,
            width   : "250px",
            cell    : row => (
                <span>
                    <i className="mdi mdi-calendar me-1 font-medium-2" />
                    {dateFormatter({
                        date    : row?.createdAt,
                        formatAs: DATE_FORMAT_VIEW
                    })}
                </span>
            )
        },
        {
            name: "Actions",
            cell: row => (
                <>
                    <LoadingButton
                        className="me-1"
                        color="info"
                        outline
                        id={`${row._id}-edit-button`}
                        icon="pencil"
                        onClick={() => handleRowActions(row, "edit")}/>
                    <LoadingButton
                        outline
                        color="danger"
                        id={`${row._id}-edit-delete`}
                        icon="delete"
                        onClick={() => handleRowActions(row, "delete")}/>
                </>
            )
        }
    ];
};
